export const TYPE_EDITOR_SET_STATE = 'TYPE_EDITOR_SET_STATE'
export const TYPE_EDITOR_SPRITE_FILTER_CHOOSING = 'TYPE_EDITOR_SPRITE_FILTER_CHOOSING'
export const TYPE_EDITOR_SPRITE_FILTER_CLOSED = 'TYPE_EDITOR_SPRITE_FILTER_CLOSED'
